var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.track)?_c('AudioTrackConsumer',{attrs:{"track":_vm.track,"muted":_vm.muted}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }